//@flow
import * as React from 'react';
import type { ComponentType } from 'react';
import { themr } from 'react-css-themr';
import defaultTheme from 'react-toolbox/lib/tabs/theme.scss';
import { CardTabs } from './CustomTabs';

type Props = {
    children: React.Node,
    onChange: (number, ?string) => void,
    activeTabId?: string,
    activeTabIndex?: number
};

const withTabKeys = (TabsComponent: ComponentType<any>) => {
    class EnhancedTabs extends React.PureComponent<Props> {
        onChange = index => {
            const { onChange, children } = this.props;
            // In cases where we want a stringId, not just index
            const { tabId } = children[index].props;
            onChange(index, tabId);
        };

        getActiveTabIndex = () => {
            const { activeTabId, activeTabIndex, children } = this.props;
            if (activeTabId) {
                return children.findIndex(
                    child => child.props.tabId === activeTabId
                );
            }
            return activeTabIndex;
        };
        render() {
            return (
                <TabsComponent
                    {...this.props}
                    index={this.getActiveTabIndex()}
                    onChange={this.onChange}
                />
            );
        }
    }
    return themr('ThemedEnhancedTabs', defaultTheme)(EnhancedTabs);
};

const EnhancedCardTabs = withTabKeys(CardTabs);
export { EnhancedCardTabs };
export default withTabKeys;
